const toggleButton = document.getElementById('site-navigation-button');
const navigationContent = document.getElementById('site-navigation-content');

const toggleButtonActiveClassName = 'hamburger--active';
const navigationContentActiveClassName = 'navigation__content--active';

if (toggleButton) {
    toggleButton.addEventListener('click', e => {
        const isActive = toggleButton.getAttribute('aria-expanded') === 'true';
        if (isActive) {
            navigationContent.classList.remove(navigationContentActiveClassName);
            toggleButton.classList.remove(toggleButtonActiveClassName);
            toggleButton.setAttribute('aria-expanded', 'false');
        } else {
            navigationContent.classList.add(navigationContentActiveClassName);
            toggleButton.classList.add(toggleButtonActiveClassName);
            toggleButton.setAttribute('aria-expanded', 'true');
        }
    });
}

const menuItemsWithFlyouts = Array.from(document.querySelectorAll('.menu__item--has-descendants'));
const menuItemActiveClassName = 'menu__item--active';

menuItemsWithFlyouts.forEach(item => {
    const node = item.querySelector('.menu__node');

    // Enter key activates the item so the click event handler doesn't prevent the navigation.
    node.addEventListener('keydown', e => {
        if ('Enter' !== e.key) return;
        item.classList.add(menuItemActiveClassName);
    });

    // Open the flyout on click.
    node.addEventListener('click', e => {
        // Let the click go through if the item is already active or visible by hovering.
        const isActive = item.classList.contains(menuItemActiveClassName) || item.matches(':hover');
        if (isActive) return;

        item.classList.add(menuItemActiveClassName);
        e.preventDefault();
    });

    // Close the flyout when focus moves out of it.
    node.addEventListener('focusout', e => {
        if (item.contains(e.relatedTarget)) return;
        item.classList.remove(menuItemActiveClassName);
    });
});
